import { motion } from 'framer-motion'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ColumnsTable, HeaderActions, ICreateRefund, ISell } from 'safe'
import Empty from '../../components/Display/Empty'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { RootState } from '../../redux/store'
import EmptyHistoric from '../../assets/animations/historico.json'
import {
  dateToDB,
  formatPipe,
  formatter,
  getDenomination,
  getYearMonthAndDay,
  transformDate,
} from '../../utils/utils'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import Modal from '../../components/Display/Modal'
import { fetchFreeForms, fetchSells } from '../../redux/actions/sells'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { HiArrowLeft, HiDotsVertical } from 'react-icons/hi'
import ModalConfirm from '../../components/Display/ModalConfirm'
import { createRefundSell } from '../../redux/actions/refund'
import { tax } from '../../userConfig'
import Sells, { IGlobalRate } from './Sells'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import DescriptionRefundForm from './DescriptionRefundForm'
import ModalSearchHistoric from './ModalSearchHistoric'
import InvoicePdf from './InvoicePdf'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import PdfView from '../../components/Display/PdfView'
import { useHistory } from 'react-router'
import axios from 'axios'
import {
  fetchHistoricDeliveryNotes,
  onRevertSaleDeliveryNote,
} from '../../redux/actions/sales_delivery_note'
import FloatingForm from '../../components/Display/FloatingForm'
import FloatingSaleHistoricSearch from '../../components/Display/FloatingSaleHistoricSearch'
import AddPayments from '../Purchases/Purchase/AddPayments'
import Return from '../Purchases/Purchase/Return'
import WatchSale from './WatchSale'
import DownloadPdf from './DownloadPdf'
import PdfSale from './PdfSale'
import { uploadToS3 } from '../../utils/UploadFile'
import WithholdingForm from './WithholdingForm'
import AddPaymentForm from '../Purchases/Purchase/AddPaymentForm'
import OtherWithholding from './OtherWithholding'
import WatchWithholding from './WatchWithholding'
import { toFixed } from 'accounting'

enum accountTypeEnum {
  CASH = 'CASH',
  BANKACCOUNT = 'BANK ACCOUNT',
  CARD = 'CARD',
  'MOBILE PAYMENT' = 'MOBILE PAYMENT',
  WALLET = 'WALLET',
}

const server = process.env.REACT_APP_SERVER_URL
const HistoricSells: React.FC<HistoricSellsProps> = ({ setHeaderActions }) => {
  const sells = useSelector((state: RootState) => state.slls.sells)
  const numberOfPages = useSelector(
    (state: RootState) => state.slls.numberOfPages
  )
  const deliveryNotes = useSelector(
    (state: RootState) => state.sdlvn.deliveryNotes
  )

  const numberOfPagesDeliveryNotes = useSelector(
    (state: RootState) => state.sdlvn.numberOfPages
  )

  const { addAlert } = useSnackBars()

  const dispatch = useDispatch()

  const [currentPage, setCurrentPage] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)

  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])
  const [modalFromRow, setModalFromRow] = useState<boolean>(false)

  const [userConfig] = useLocalStorageState('user-config')

  const [searchModal, setSearchModal] = useState<boolean>(false)

  const [searchParams, setSearchParams] = useState<string[]>([])

  const [menuVisible, setMenuVisible] = useState('')

  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const [showAddPaymentForm, setShowAddPaymentForm] = useState<boolean>(false)

  const [invoiceMethod, setInvoiceMethod] = useState<any>(null)


  const [selectedSale, setSelectedSale] = useState<
    | (ISell & {
        fixedDate: string
        itemDeliveryNote: {
          amount: string
          id_delivery_note: string
          id_item: string
          id_item_delivery_note: string
        }[]
        paidOut: boolean
      })
    | null
  >(null)

  const user = useSelector((state: RootState) => state.auth.user)

  const [showSellComponent, setShowSellComponent] = useState<boolean>(false)

  const [modalDescription, setModalDescription] = useState<boolean>(false)

  const [descriptionRefund, setDescriptionRefund] = useState<string>('')

  const [selectedType, setSelectedType] = useState<string>('all')

  const [showPdf, setShowPdf] = useState<boolean>(false)

  const [all, setAll] = useState<any>([])

  const [numberOfPagesAll, setNumberOfPagesAll] = useState<number>(0)

  const [showSale, setShowSale] = useState<boolean>(false)

  const [deleteSaleId, setDeleteSale] = useState<string | null>(null)

  // const [showConfirmModal, setShowConfirmModal] = useState(second)

  const [showAddPayment, setShowAddPayment] = useState<boolean>(false)

  const [addPaymentSelected, setAddPaymentSelected] = useState<any>(null)

  const [showReturnModal, setShowReturnModal] = useState<boolean>(false)

  const [returnSelected, setReturnSelected] = useState<any>(null)

  const [watchSale, setWatchSale] = useState<any>(null)

  const [fromReturn, setFromReturn] = useState<boolean>(false)

  const [showReprint, setShowReprint] = useState<boolean>(false)

  const [reprintBody, setReprintBody] = useState<any | null>(null)

  const [isFromHistory, setIsFromHistory] = useState<boolean>(false)

  const [globalRate, setGlobalRate] = useState<IGlobalRate[]>([])

  const [showWithholdingModal, setShowWithholdingModal] = useState<boolean>(
    false
  )

  const [otherWithholdingModal, setOtherWithholdingModal] = useState<boolean>(
    false
  )

  const [selectedWithholding, setSelectedWithholding] = useState<any>(null)

  const [fastSearch, setFastSearch] = useState<string>('')

  const [title, setTitle] = useState<string>('IVA')

  const [
    showModalWithholdingDetails,
    setShowModalWithholdingDetails,
  ] = useState<boolean>(false)

  const [selectedDeleteSale, setSelectedDeleteSale] = useState<string | null>(
    null
  )

  const objReplace = {
    [accountTypeEnum.BANKACCOUNT]: 'Cuenta Bancaria',
    [accountTypeEnum.CARD]: 'Punto de venta',
    [accountTypeEnum.CASH]: 'Efectivo',
    [accountTypeEnum['MOBILE PAYMENT']]: 'Pago Movil',
    [accountTypeEnum.WALLET]: 'Billetera Virtual',
  }

  const history = useHistory()

  const objType = {
    COUNTERFOIL: 'Talonario',
    INVOICE: 'Factura',
    'FREE FORM': 'Forma libre',
  }

  const getSale = async (
    params: string[] = [],
    pageNumber: number = 0,
    fastParam = fastSearch
  ) => {
    const paginationParams = [
      `pageNumber=${pageNumber + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]

    let newParams = [...params]

    if (fastParam) {
      newParams.push(`fastSearch=${fastParam}`)
    }

    setCurrentPage(pageNumber)
    setSearchParams(params)
    setFastSearch(fastParam)
    setLoading(true)
    try {
      await onGetInvoiceMethod()
      await dispatch(fetchSells(newParams, paginationParams))
    } catch (err) {
      addAlert({ message: 'Error al obtener las ventas', status: 'error' })
    } finally {
      setLoading(false)
    }
  }

  const getFreeForm = async (): Promise<void> => {
    setLoading(true)
    try {
      await dispatch(
        fetchFreeForms(searchParams, [
          `pageNumber=${currentPage + 1}`,
          `pageSize=${userConfig.rowsPerPage}`,
        ])
      )
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }

  const getAll = async (
    searchParamsProps: string[],
    pageNumber: number = 0
  ): Promise<void> => {
    setSearchParams(searchParamsProps)
    setCurrentPage(pageNumber)
    let params = [
      ...searchParamsProps,
      `pageNumber=${pageNumber + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]
    setLoading(true)
    try {
      let response = await axios.get(
        `${server}/business/sale/invoice/free-form?${params.join('&')}`
      )
      setAll(
        response.data.sales.map((sale) => ({
          ...sale,
          numberOfItems:
            sale.type === 'FREE FORM'
              ? sale.freeForm.freeFormDetail.items.length
              : sale.invoice.invoiceDetail.items.length,
        }))
      )
      setNumberOfPagesAll(response.data.numberOfPages)
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }

  const getDeliveryNotes = async (
    searchParamsProps: string[],
    pageNumber: number = 0
  ): Promise<void> => {
    setSearchParams(searchParamsProps)
    setCurrentPage(pageNumber)
    await dispatch(
      fetchHistoricDeliveryNotes(searchParamsProps, [
        `pageNumber=${pageNumber + 1}`,
        `pageSize=${userConfig.rowsPerPage}`,
      ])
    )
  }

  const onFormatITems = (): any => {
    return selectedSale?.items.map((item) => {
      return {
        ...item,
        //@ts-ignore
        ...selectedSale.itemSale.find((it) => it.id_item === item.id),
      }
    })
  }

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const onGetInvoiceMethod = async () => {
    let response = await axios.get(`${server}/user/tenant`)
    setInvoiceMethod(response.data.tenant.invoiceMethod)
  }

  const onCreateRefund = async () => {
    // let paymentMethodType = {
    //   "Billetera Virtual": "WALLET",
    //   "Cuenta Bancaria": "TRANSFERENCE",
    //   "Efectivo": "CASH",
    //   "Punto de venta": "CARD",
    //   "Pago Móvil": 'MOBILE PAYMENT'
    // }

    console.log('selected sale', selectedSale)
    if (selectedSale) {
      const refund: ICreateRefund = {
        client: {
          id: selectedSale?.client.id,
        },
        sale: {
          id: selectedSale?.id,
        },
        load: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          items: selectedSale.items.map((item) =>
            ((v) => ({ idItem: item.id, amount: v?.amount }))(
              selectedSale.itemSale?.find(
                (itemSale) => itemSale.id_item === item.id
              )
            )
          ),
        },
        [selectedType === 'all'
          ? selectedSale.type === 'FREE FORM'
            ? 'freeForm'
            : 'invoice'
          : selectedType]: {
          id: selectedSale.invoice.id,
          refund: true,
          description: descriptionRefund,
          creditNote: '',
        },
        payments: selectedSale.payments.map((payment) => ({
          idAccount: payment.account,
          amount: +payment.amount,
          details: 'REFUND',
          transactionType: 'EXPENSES',
          receipt: payment.receipt,
        })),
      }

      let replaceValue = {
        á: 'a',
        é: 'é',
        í: 'i',
        ó: 'o',
        ú: 'u',
      }

      let objToRefund = {
        invoice: {
          tax: '',
          tax_base: '',
          exempt: '',
          total: '',
          invoiceNumber: selectedSale.invoice.invoiceDetail?.invoiceNumber,
          cashier: {
            seller: 'Samuel Boza',
            safeBox: 'Caja 1',
            serial: '123456789',
          },
          client: {
            name: selectedSale?.client.name,
            surname: selectedSale?.client.surname,
            document: {
              document: selectedSale?.client.document,
              documentType: selectedSale?.client.documentType,
            },
            // address: 'TIERRA NEGRA',
            address: selectedSale.client.street,
            // address: selectedClient?.address?.street,
            // phone: selectedSale?.client.phones[0].number,
          },
          items: selectedSale.items?.map((item) => ({
            name: item.name.replace(/[áéíóú]/gi, (v) =>
              replaceValue[v.toLowerCase()].toUpperCase()
            ),
            amount:
              selectedSale.itemSale?.find((it) => it.id_item === item.id)
                ?.amount + '',
            // price: !item.exempt
            //   ? (
            //       +item?.price[item?.price?.length - 1]?.amount /
            //       Number(`1.${tax}`)
            //     ).toFixed(2)
            //   : Number(item.price[item.price.length - 1].amount).toFixed(2),
            exempt: item.exempt,
          })),
          payments: selectedSale.payments.map((method) => ({
            paymentMethod: method.details,
            amount: Number(method.amount).toFixed(2),
          })),
        },
      }


      addAlert({ message: 'Creando devolución', status: 'loading' })

      if (selectedSale.type === 'FREE FORM') {
        try {
          if (selectedType === 'all') {
            await axios.post(`${server}${'/business/sale/refund/free-form'}`, {
              refund,
            })
          } else {
            await dispatch(
              createRefundSell(
                refund,
                selectedSale.id,
                (selectedType === 'all' && selectedSale.type === 'FREE FORM') ||
                  selectedType === 'freeForm'
              )
            )
          }
          // setSelectedSale(null)
          // setAlreadySelled(true)
          addAlert({
            message: 'Devolución creada con exito!',
            status: 'success',
          })

          setShowPdf(true)
        } catch (err) {
          addAlert({
            message: 'Error al crear una devolución!',
            status: 'error',
          })
        } finally {
          setShowConfirmModal(false)
          setModalDescription(false)
        }

        return
      }

      let headers = new Headers()
      headers.append('Content-Type', 'application/json')
      headers.append('Accept', 'application/json')

      fetch('http://127.0.0.1:5000/api/devolucion', {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(objToRefund),
        headers,
      })
        .then((v) => {
          return v.json()
        })
        .then(async (res) => {
          if (res?.Error) {
            addAlert({ message: res?.Error, status: 'error' })
            return
          }
          try {
            const refundBody = {
              ...refund,
              [selectedType === 'all'
                ? selectedSale.type === 'FREE FORM'
                  ? 'freeForm'
                  : 'invoice'
                : selectedType]: {
                ...refund[
                  selectedType === 'all'
                    ? selectedSale.type === 'FREE FORM'
                      ? 'freeForm'
                      : 'invoice'
                    : selectedType
                ],
                creditNote: res.invoice_number,
              },
            }

            if (selectedType === 'all') {
              await axios.post(`${server}${'/business/sale/refund/invoice'}`, {
                refund,
              })
            } else {
              await dispatch(
                createRefundSell(
                  refundBody,
                  selectedSale.id,
                  (selectedType === 'all' && selectedSale.type === 'INVOICE') ||
                    selectedType === 'freeForm'
                )
              )
            }

            // setSelectedSale(null)
            // setAlreadySelled(true)
            addAlert({
              message: 'Devolución creada con exito!',
              status: 'success',
            })

            setShowSellComponent(true)
          } catch (err) {
            addAlert({
              message: 'Error al crear una devolución!',
              status: 'error',
            })
          } finally {
            setShowConfirmModal(false)
            setModalDescription(false)
          }
        })
        .catch((err) => {
          addAlert({ message: 'Error con máquina fiscal', status: 'error' })
        })
    }
  }

  useEffect(() => {
    // console.log('selected type', selectedType)
    // if (selectedType === 'freeForm') {
    //   getFreeForm()
    // } else if (selectedType === 'all') {
    //   getAll([...searchParams], currentPage)
    // } else if (selectedType === 'deliveryNote') {
    //   getDeliveryNotes([...searchParams], currentPage)
    // } else {
    //   getSells()
    // }
    getSale()
  }, [])

  useEffect(() => {
    setHeaderActions({
      advancedSearch: async (value) => {
        if (typeof value === 'boolean') {
          setSearchModal(value)
          return
        }
        getSale(searchParams, currentPage, value)
        // if (currentPage === 0) {
        //   // getPurchases([`fastSearch=${value}`])
        // } else {
        //   setSearchParams([`fastSearch=${value}`])
        //   setCurrentPage(0)
        // }
      },
      // searchAction: () => setSearchModal(true),
      // onFilterSales: async (checked: boolean) => {
      //   if (selectedType === 'deliveryNote') {
      //     if (checked) {
      //       setSearchParams((prevState) => [
      //         ...prevState,
      //         `reversed=${checked}`,
      //       ])
      //       if (currentPage === 0) {
      //         setLoading(true)
      //         try {
      //           await dispatch(
      //             fetchHistoricDeliveryNotes(
      //               [...searchParams, `reversed=${checked}`],
      //               [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //             )
      //           )
      //         } catch (err) {
      //         } finally {
      //           setLoading(false)
      //         }
      //       }
      //       setCurrentPage(0)
      //     } else {
      //       setSearchParams((prevState) =>
      //         prevState.filter((old) => !old.includes('reversed'))
      //       )
      //       if (currentPage === 0) {
      //         setLoading(true)
      //         try {
      //           await dispatch(
      //             fetchHistoricDeliveryNotes(
      //               searchParams.filter((param) => !param.includes('reversed')),
      //               [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //             )
      //           )
      //         } catch (err) {
      //         } finally {
      //           setLoading(false)
      //         }
      //       }
      //       setCurrentPage(0)
      //     }
      //   } else if (selectedType === 'freeForm') {
      //     if (checked) {
      //       setSearchParams((prevState) => [...prevState, `refund=${checked}`])
      //       if (currentPage === 0) {
      //         setLoading(true)
      //         try {
      //           await dispatch(
      //             fetchFreeForms(
      //               [...searchParams, `refund=${checked}`],
      //               [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //             )
      //           )
      //         } catch (err) {
      //         } finally {
      //           setLoading(false)
      //         }
      //       }
      //       setCurrentPage(0)
      //     } else {
      //       console.log('los filtros aca', searchParams)
      //       setSearchParams((prevState) =>
      //         prevState.filter((old) => !old.includes('refund'))
      //       )
      //       if (currentPage === 0) {
      //         setLoading(true)
      //         try {
      //           await dispatch(
      //             fetchFreeForms(
      //               searchParams.filter((param) => !param.includes('refund')),
      //               [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //             )
      //           )
      //         } catch (err) {
      //         } finally {
      //           setLoading(false)
      //         }
      //       }
      //       setCurrentPage(0)
      //     }
      //   } else if (selectedType === 'all') {
      //     if (checked) {
      //       try {
      //         getAll([...searchParams, `refund=${checked}`], 0)
      //       } catch (err) {
      //       } finally {
      //         setLoading(false)
      //       }
      //       // setSearchParams((prevState) => [...prevState, `refund=${checked}`])
      //       // if (currentPage === 0) {
      //       //   setLoading(true)
      //       //   try {
      //       //     await dispatch(
      //       //       fetchFreeForms(
      //       //         [...searchParams, `refund=${checked}`],
      //       //         [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //       //       )
      //       //     )
      //       //   } catch (err) {
      //       //   } finally {
      //       //     setLoading(false)
      //       //   }
      //       // }
      //       // setCurrentPage(0)
      //     } else {
      //       try {
      //         getAll(
      //           searchParams.filter((param) => !param.includes('refund')),
      //           0
      //         )
      //       } catch (err) {
      //       } finally {
      //       }
      //       // console.log('los filtros aca', searchParams)
      //       // setSearchParams((prevState) =>
      //       //   prevState.filter((old) => !old.includes('refund'))
      //       // )
      //       // if (currentPage === 0) {
      //       //   setLoading(true)
      //       //   try {
      //       //     await dispatch(
      //       //       fetchFreeForms(
      //       //         searchParams.filter((param) => !param.includes('refund')),
      //       //         [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //       //       )
      //       //     )
      //       //   } catch (err) {
      //       //   } finally {
      //       //     setLoading(false)
      //       //   }
      //       // }
      //       // setCurrentPage(0)
      //     }
      //   } else {
      //     if (checked) {
      //       setSearchParams((prevState) => [...prevState, `refund=${checked}`])
      //       if (currentPage === 0) {
      //         setLoading(true)
      //         await dispatch(
      //           fetchSells(
      //             [...searchParams, `refund=${checked}`],
      //             [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //           )
      //         )
      //         setLoading(false)
      //       }
      //       setCurrentPage(0)
      //     } else {
      //       setSearchParams([])
      //       if (currentPage === 0) {
      //         setLoading(true)
      //         await dispatch(
      //           fetchSells(
      //             [],
      //             [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //           )
      //         )
      //         setLoading(false)
      //       }
      //       setCurrentPage(0)
      //     }
      //   }
      // },
      cleanFilters: {
        sort: () => {
          console.log('sort clean')
        },
        search: async () => {
          getSale([], 0)
          // if (selectedType === 'all') {
          //   getAll([], 0)
          // } else if (selectedType === 'deliveryNote') {
          //   getDeliveryNotes([], 0)
          // } else {
          //   setSearchParams([])
          //   if (currentPage === 0) {
          //     setLoading(true)
          //     if (selectedType === 'freeForm') {
          //       try {
          //         await dispatch(
          //           fetchFreeForms(
          //             [],
          //             [
          //               `pageNumber=${currentPage + 1}`,
          //               `pageSize=${userConfig.rowsPerPage}`,
          //             ]
          //           )
          //         )
          //       } catch (err) {
          //       } finally {
          //         setLoading(false)
          //       }
          //     } else {
          //       await dispatch(
          //         fetchSells(
          //           [],
          //           [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
          //         )
          //       )
          //     }
          //     setLoading(false)
          //   }
          //   setCurrentPage(0)
          // }
        },
        isSearch: Boolean(searchParams.length > 0),
      },
      // onChangeType: async (v: string) => {
      //   setSelectedType(v)
      //   setCurrentPage(0)
      //   if (v === 'all') {
      //     getAll([], 0)
      //   } else if (v === 'deliveryNote') {
      //     getDeliveryNotes([], 0)
      //   } else if (v === 'freeForm') {
      //     setLoading(true)
      //     try {
      //       await dispatch(
      //         fetchFreeForms(searchParams, [
      //           `pageNumber=${1}`,
      //           `pageSize=${userConfig.rowsPerPage}`,
      //         ])
      //       )
      //     } catch (err) {
      //     } finally {
      //       setLoading(false)
      //     }
      //   } else {
      //     getSells()
      //   }
      // },
      // onChangeToDelivery: () => {
      //   history.push('/dashboard/notadeentrega/historiconotas')
      // },
    })
    return () => {
      setHeaderActions(null)
    }
  }, [setHeaderActions, searchParams, currentPage, selectedType])

  const onFilterOptions = (sale, options) => {
    if (sale?.withholding?.id || sale?.paidOut) {
      delete options.withholdingIVA
    }
    if (sale?.islrWithholding?.id || sale?.paidOut) {
      delete options?.withholdingISLR
    }

    if (sale?.aeWithholding?.id || sale?.paidOut) {
      delete options?.aeWithholding
    }

    if (sale?.otherWithholding?.length > 0 || sale?.paidOut) {
      delete options?.otherWitholding
    }

    if (sale?.paidOut) {
      delete options?.onAddPayment
    }

    if (invoiceMethod !== 'free_form') {
      delete options?.onReprint
    }

    if (sale?.cancelled || invoiceMethod !== 'free_form') {
      delete options?.onCancelInvoice
    }

    // Solo mostrar "Descargar Factura" si el método de facturación es digital
    if (invoiceMethod !== 'digital') {
      delete options?.onDownloadDigitalInvoice
    }

    // Solo mostrar "Descargar Retención IVA" si el método de facturación es digital y hay ivaPdfUrl
    if (invoiceMethod !== 'digital' || !sale?.ivaPdfUrl) {
      delete options?.onDownloadIvaRetention
    }

    // Solo mostrar "Descargar Retención ISLR" si el método de facturación es digital y hay islrPdfUrl
    if (invoiceMethod !== 'digital' || !sale?.islrPdfUrl) {
      delete options?.onDownloadIslrRetention
    }

    // if (reprintBody) {
    //   return {OnPrintProps: reprintBody}
    // }
    if (sale?.return) {
      // if (sale.withholding.id) {
      //   const { onReturn, withholdingIVA, withholdingISLR, ...op } = options
      //   return op
      // }
      const { onReturn, ...op } = options
      if (!sale?.paidOut) return op
      const { onAddPayment, ...rest } = op
      return rest
    }
    if (sale.paidOut) {
      const { onReturnEdit, ...rest } = options
      return rest
    }
    const { onReturnEdit, ...op } = options
    if (!sale.paidOut) return op
    // const { onAddPayment, withholdingIVA, withholdingISLR , ...rest } = op
    return options
  }

  const columns: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'startedDate',
      key: 'startedDate',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {transformDate(new Date(record?.date).toISOString())}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Monto',
      dataIndex: 'client.cost',
      key: 'client.cost',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {/* {transformDate(new Date(record?.date).toISOString())} */}
          {`${getDenomination(record?.currency?.id)} ${formatPipe(
            record?.cost
          )}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Nombre del cliente',
      dataIndex: 'client.name',
      key: 'client.name',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record?.client?.businessName || record?.client?.name}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Documento',
      dataIndex: 'invoice.tax',
      key: 'invoice.tax',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {`${record?.client?.documentType}-${record?.client?.document}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Número de factura',
      dataIndex: 'invoice.code',
      key: 'invoice.code',
    },
    {
      title: 'Usuario',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Estado',
      dataIndex: 'paidOut',
      key: 'paidOut',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record?.cancelled
            ? 'Anulada'
            : record?.paidOut
            ? 'Pagado'
            : 'Pendiente de pago'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'center',
      key: '',
      render: (id: string, sale: any) => {
        return (
          <ColumnItemWrapper floatingMenu>
            <FloatingMenu
              visible={id === menuVisible}
              onClose={() => setMenuVisible('')}
              options={onFilterOptions(sale, {
                // onDelete: async () => {
                //   //  setShowDeleteSaleModal(true)
                //   setSelectedDeleteSale(id)
                // },
                onCancelInvoice: async () => {
                  setShowConfirmModal(true)
                  setDeleteSale(sale.id)
                },
                onReprint: async () => {
                  let response = await axios.get(`${server}/sale?id=${sale.id}`)
                  let date = sale.date.replace(/T.+/, '')
                  let responseRate = await axios.get<{ rates: IGlobalRate[] }>(
                    `${server}/finances/rate?date=${date}&currency=all`
                  )
                  setIsFromHistory(true)
                  setGlobalRate(responseRate.data.rates)

                  let itemsList : any[] = []

                  let items = response?.data?.sale?.items

                  let services = response?.data?.sale?.services

                  if (items) {
                    itemsList = [...itemsList, ...items]
                  }

                  if (services) {
                    itemsList = [...itemsList, ...services]
                  }

                  setReprintBody({
                    ...response.data.sale,
                    usd: +response.data.sale.cost / +response.data.sale.usdCost,
                    items: itemsList,
                  })
                },
                // onReprint: async () => {
                //   let response = await axios.get(`${server}/sale?id=${sale.id}`)
                //   const reprintBody = {
                //     data: response?.data?.sale?.items.map(item => ({
                //       amount: item?.amount,
                //       description: item?.name,
                //       individualPrice: +item?.price,
                //       totalPrice: +item?.price * + +item?.amount
                //     })),
                //     subTotal: "",
                //     descuento: response?.data?.sale?.discount,
                //     igtf: response?.data?.sale?.igtf,
                //     iva: response?.data?.sale?.iva,
                //     total: response?.data?.sale?.cost,
                //     client: {
                //       name: response?.data?.sale?.client?.name,
                //       rif: `${response?.data?.sale?.client?.documentType}-${response?.data?.sale?.client?.document}`,
                //       address: "",
                //       phone: "",
                //       city: "",
                //       state: ""
                //     },
                //     paidOut: response?.data?.sale?.paidOut,
                //     invoiceNumber: response?.data?.sale?.invoice?.code
                //   }
                //   // pdf(<PdfSale {...reprintBody} />).toBlob().then((blob) => uploadToS3(blob, {value: "cr7"}, ""))
                //   // setReprintBody(reprintBody)
                //   // setShowReprint(true)
                // },
                onReturn: async () => {
                  let response = await axios.get(`${server}/sale?id=${sale.id}`)
                  // setSelectedSale(sale)
                  // setModalDescription(true)
                  // setShowConfirmModal(true)
                  setReturnSelected(response.data.sale)
                  setFromReturn(true)
                  setShowReturnModal(true)
                },
                onReturnEdit: async () => {
                  let response = await axios.get(`${server}/sale?id=${sale.id}`)
                  // setFromReturn(true)
                  setReturnSelected(response.data.sale)
                  setShowReturnModal(true)
                },
                onAddPayment: async () => {
                  let response = await axios.get(`${server}/sale?id=${sale.id}`)
                  setAddPaymentSelected({
                    ...response.data.sale,
                    purchase: response.data.sale?.payments?.map((v) => ({
                      ...v,
                      new: false,
                    })),
                  })
                  setShowAddPayment(true)
                },
                // onCancelSale: async () => {
                //   setShowConfirmModal(true)
                //   setDeleteSale(sale.id)
                // },
                watchSale: async () => {
                  let response = await axios.get(`${server}/sale?id=${sale.id}`)
                  let date = sale.date.replace(/T.+/, '')
                  let responseRate = await axios.get<{ rates: IGlobalRate[] }>(
                    `${server}/finances/rate?date=${date}&currency=all`
                  )
                  setGlobalRate(responseRate.data.rates)

                  setWatchSale(response?.data?.sale)
                },
                onDownloadDigitalInvoice: async () => {
                  if (sale.pdfUrl) {
                    try {
                      addAlert({
                        message: 'Descargando factura digital...',
                        status: 'loading',
                      })

                      // Descargar el PDF desde la URL
                      const response = await fetch(sale.pdfUrl)
                      if (!response.ok) {
                        throw new Error('Error al descargar el PDF')
                      }

                      const blob = await response.blob()
                      const url = window.URL.createObjectURL(blob)
                      const link = document.createElement('a')
                      link.href = url
                      link.download = `factura-digital-${sale.invoice?.code || sale.id}.pdf`
                      document.body.appendChild(link)
                      link.click()
                      document.body.removeChild(link)
                      window.URL.revokeObjectURL(url)

                      addAlert({
                        message: 'Factura descargada exitosamente',
                        status: 'success',
                      })
                    } catch (error) {
                      console.error('Error al descargar factura digital:', error)
                      addAlert({
                        message: 'Error al descargar la factura digital',
                        status: 'error',
                      })
                    }
                  } else {
                    addAlert({
                      message:
                        'No existe registro de esta factura en el sistema. Por favor contacta a la Imprenta Digital',
                      status: 'error',
                      duration: 5000,
                    })
                  }
                },
                onDownloadIvaRetention: async () => {
                  if (sale.ivaPdfUrl) {
                    try {
                      addAlert({
                        message: 'Descargando retención IVA...',
                        status: 'loading',
                      })

                      // Descargar el PDF desde la URL
                      const response = await fetch(sale.ivaPdfUrl)
                      if (!response.ok) {
                        throw new Error('Error al descargar el PDF')
                      }

                      const blob = await response.blob()
                      const url = window.URL.createObjectURL(blob)
                      const link = document.createElement('a')
                      link.href = url
                      link.download = `retencion-iva-${sale.invoice?.code || sale.id}.pdf`
                      document.body.appendChild(link)
                      link.click()
                      document.body.removeChild(link)
                      window.URL.revokeObjectURL(url)

                      addAlert({
                        message: 'Retención IVA descargada exitosamente',
                        status: 'success',
                      })
                    } catch (error) {
                      console.error('Error al descargar retención IVA:', error)
                      addAlert({
                        message: 'Error al descargar la retención IVA',
                        status: 'error',
                      })
                    }
                  } else {
                    addAlert({
                      message:
                        'No existe registro de esta retención IVA en el sistema',
                      status: 'error',
                      duration: 5000,
                    })
                  }
                },
                onDownloadIslrRetention: async () => {
                  if (sale.islrPdfUrl) {
                    try {
                      addAlert({
                        message: 'Descargando retención ISLR...',
                        status: 'loading',
                      })

                      // Descargar el PDF desde la URL
                      const response = await fetch(sale.islrPdfUrl)
                      if (!response.ok) {
                        throw new Error('Error al descargar el PDF')
                      }

                      const blob = await response.blob()
                      const url = window.URL.createObjectURL(blob)
                      const link = document.createElement('a')
                      link.href = url
                      link.download = `retencion-islr-${sale.invoice?.code || sale.id}.pdf`
                      document.body.appendChild(link)
                      link.click()
                      document.body.removeChild(link)
                      window.URL.revokeObjectURL(url)

                      addAlert({
                        message: 'Retención ISLR descargada exitosamente',
                        status: 'success',
                      })
                    } catch (error) {
                      console.error('Error al descargar retención ISLR:', error)
                      addAlert({
                        message: 'Error al descargar la retención ISLR',
                        status: 'error',
                      })
                    }
                  } else {
                    addAlert({
                      message:
                        'No existe registro de esta retención ISLR en el sistema',
                      status: 'error',
                      duration: 5000,
                    })
                  }
                },
                withholdingIVA: () => {
                  setTitle('IVA')
                  setSelectedWithholding(sale)
                  setShowWithholdingModal(true)
                },
                withholdingISLR: () => {
                  setTitle('ISLR')
                  setSelectedWithholding(sale)
                  setShowWithholdingModal(true)
                },
                otherWitholding: () => {
                  setTitle('OTHER')
                  setSelectedWithholding(sale)
                  setShowWithholdingModal(true)
                },
                aeWithholding: () => {
                  setTitle('Impuesto Municipal')
                  setSelectedWithholding(sale)
                  setShowWithholdingModal(true)
                },
                // onReprint: async () => {
                //   console.log('ID', sale)
                //   setSelectedSale(sale)
                //   if (sale.type === 'FREE FORM') {
                //     setShowPdf(true)
                //     return
                //   }

                //   let headers = new Headers()
                //   headers.append('Content-Type', 'application/json')
                //   headers.append('Accept', 'application/json')

                //   fetch('http://127.0.0.1:5000/api/reimprimir', {
                //     method: 'POST',
                //     mode: 'cors',
                //     body: JSON.stringify({
                //       invoiceNumber: sale.invoice.invoiceDetail.invoiceNumber,
                //     }),
                //     headers,
                //   })
                //     .then((v) => {
                //       return v.json()
                //     })
                //     .then(async (res) => {
                //       if (res?.Error) {
                //         addAlert({ message: res?.Error, status: 'error' })
                //         return
                //       }
                //       addAlert({
                //         message: 'Reimpresión realizada con exito',
                //         status: 'success',
                //       })
                //       setShowSellComponent(true)

                //       setShowConfirmModal(false)
                //       setModalDescription(false)
                //     })
                //     .catch((err) => {
                //       addAlert({
                //         message: 'Error con máquina fiscal',
                //         status: 'error',
                //       })
                //     })
                // },
              })}
            >
              <HiDotsVertical
                className="cursor-pointer text-gray-400"
                onClick={() => setMenuVisible(id)}
              />
            </FloatingMenu>
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const columnsAll: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'startedDate',
      key: 'startedDate',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {formatter(record?.finishedDate)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Cliente',
      dataIndex: 'client.name',
      key: 'client.name',
    },
    {
      title: 'Artículos',
      dataIndex: 'numberOfItems',
      key: 'numberOfItems',
    },
    {
      title: 'Impuesto',
      dataIndex: 'invoice.tax',
      key: 'invoice.tax',
    },
    {
      title: 'Subtotal',
      dataIndex: 'invoice.subTotal',
      key: 'invoice.subTotal',
    },
    {
      title: 'Total',
      dataIndex: 'invoice.total',
      key: 'invoice.total',
    },
    {
      title: 'Número',
      dataIndex: 'invoice.number',
      key: 'invoice.number',
      render: (id: string, sale: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {sale?.type === 'INVOICE'
            ? sale?.invoice?.invoiceDetail?.invoiceNumber
            : sale?.freeForm?.freeFormDetail?.correlativeNumber}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Descripción',
      dataIndex: '',
      key: '',
      align: 'center',
      width: 200,
      render: (id: string, sale: any) => (
        // <ColumnItemWrapper>
        //   <p>{ sale.invoice.refund ? sale.invoice.description : '' }</p>
        // </ColumnItemWrapper>

        //'N/A'
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${sale?.invoice.refund ? '' : 'text-gray-600'}`}
        >
          {/* NO BORRAR CONSOLE.LOG (HAY ERROR) */}
          {/* {console.log('', sale[selectedType].description)} */}
          {sale['freeForm'].refund ? sale['freeForm'].description : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Nota de crédito',
      dataIndex: 'id',
      align: 'center',
      key: '',
      render: (id: string, sale: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${sale?.invoice.refund ? '' : 'text-gray-600'}`}
        >
          {console.log('date en sale', sale)}
          {/* NO BORRAR CONSOLE.LOG (HAY ERROR) */}
          {/* {console.log('', sale[selectedType].description)} */}
          {sale['freeForm'].refund ? sale['freeForm'].creditNote : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      align: 'center',
      key: '',
      render: (id: string, sale: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {objType[sale.type]}
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'center',
      key: '',
      render: (id: string, sale: any) => {
        console.log('SALE', sale)
        if (!sale.invoice.refund) {
          return (
            <ColumnItemWrapper floatingMenu>
              <FloatingMenu
                visible={id === menuVisible}
                onClose={() => setMenuVisible('')}
                options={{
                  onRefund: () => {
                    console.log('VER SALE', sale)
                    setSelectedSale(sale)
                    setModalDescription(true)
                    // setShowConfirmModal(true)
                  },
                  onReprint: async () => {
                    setSelectedSale(sale)
                    if (sale.type === 'FREE FORM') {
                      setShowPdf(true)
                      return
                    }

                    let headers = new Headers()
                    headers.append('Content-Type', 'application/json')
                    headers.append('Accept', 'application/json')

                    fetch('http://127.0.0.1:5000/api/reimprimir', {
                      method: 'POST',
                      mode: 'cors',
                      body: JSON.stringify({
                        invoiceNumber: sale.invoice.invoiceDetail.invoiceNumber,
                      }),
                      headers,
                    })
                      .then((v) => {
                        return v.json()
                      })
                      .then(async (res) => {
                        if (res?.Error) {
                          addAlert({ message: res?.Error, status: 'error' })
                          return
                        }
                        addAlert({
                          message: 'Reimpresión realizada con exito',
                          status: 'success',
                        })
                        setShowSellComponent(true)

                        setShowConfirmModal(false)
                        setModalDescription(false)
                      })
                      .catch((err) => {
                        addAlert({
                          message: 'Error con máquina fiscal',
                          status: 'error',
                        })
                      })
                  },
                }}
              >
                <HiDotsVertical
                  className="cursor-pointer text-gray-400"
                  onClick={() => setMenuVisible(id)}
                />
              </FloatingMenu>
            </ColumnItemWrapper>
          )
        }
        return (
          <ColumnItemWrapper>
            <p className="dark:text-primaryGreen text-primaryGreen-600">
              Devuelta
            </p>
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const filterOptions = (options, deliveryNote) => {
    if (deliveryNote.payments.length === 0) {
      const { onConvertToSale, ...rest } = options
      return rest
    }
    return options
  }

  const columnsDeliveryNotes: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'startedDate',
      key: 'startedDate',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {formatter(record?.finishedDate)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Cliente',
      dataIndex: 'client.name',
      key: 'client.name',
    },
    {
      title: 'Total',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
    },
    {
      title: 'Pagado',
      dataIndex: '',
      key: '',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record?.paidOut ? 'Pagado' : 'No pagado'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Tipo',
      dataIndex: '',
      key: '',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record?.type === 'DISPATCHED' ? 'Despachado' : 'No despachado'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'center',
      key: '',
      render: (id: string, sale: any) => {
        if (sale.reversed) {
          return (
            <ColumnItemWrapper>
              <p className="dark:text-primaryGreen text-primaryGreen-600">
                Reversado
              </p>
            </ColumnItemWrapper>
          )
        }
        if (sale.sale !== null) {
          return (
            <ColumnItemWrapper>
              <p className="dark:text-primaryOrange text-primaryOrange-600">
                Convertido a Venta
              </p>
            </ColumnItemWrapper>
          )
        }
        return (
          <ColumnItemWrapper floatingMenu>
            <FloatingMenu
              visible={id === menuVisible}
              onClose={() => setMenuVisible('')}
              options={filterOptions(
                {
                  onConvertToSale: async () => {
                    setShowSale(true)
                    setSelectedSale(sale)
                  },
                  onRefund: async () => {
                    console.log('refund...')
                    const entity = {
                      id: sale.id,
                      client: {
                        id: sale?.client.id,
                      },
                      load: {
                        destination: {
                          id: '1',
                          locationType: 'warehouse',
                        },
                        items: sale?.items.map((item) => ({
                          idItem: item.id,
                          amount: sale.itemDeliveryNote.find(
                            (it) => it.id_item === item.id
                          )?.amount,
                        })),
                      },
                      cashier: 'Gustavo Parra',
                      totalPrice: +sale?.totalPrice,
                      paidOut: sale.paidOut,
                      type: sale.type,
                      reversed: true,
                      payments: sale.payments.map((payment) => ({
                        idAccount: payment.account,
                        amount: +payment.amount,
                        details: 'REFUND',
                        transactionType: 'EXPENSES',
                        receipt: payment.receipt,
                      })),
                    }
                    try {
                      addAlert({
                        message: 'Revirtiendo Nota de entrega',
                        status: 'loading',
                      })
                      await dispatch(onRevertSaleDeliveryNote(entity))
                      addAlert({
                        message: 'Reversión realizada satisfactoriamente',
                        status: 'success',
                      })
                      setSearchParams([])
                      setCurrentPage(0)
                      if (currentPage === 0) {
                        setLoading(true)
                        await dispatch(
                          fetchHistoricDeliveryNotes(
                            [],
                            [
                              `pageNumber=${1}`,
                              `pageSize=${userConfig.rowsPerPage}`,
                            ]
                          )
                        )
                        setLoading(false)
                      }
                    } catch (err) {
                    } finally {
                    }
                  },
                },
                sale
              )}
            >
              <HiDotsVertical
                className="cursor-pointer text-gray-400"
                onClick={() => setMenuVisible(id)}
              />
            </FloatingMenu>
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const getOrderKeys = (key: string) => {
    if (key === 'client.name') return ['client', 'name']
    return [key]
  }

  const pressRow = (sell: any) => {
    const sellsDetails = { title: '', data: '' }
    const itemsDetails = { title: '', data: '' }

    sellsDetails.title = 'Detalles de Venta'
    sellsDetails.data += `Fecha de Apertura: ${new Date(
      sell.startedDate
    ).toLocaleDateString()}\n`
    sellsDetails.data += `Fecha de Cierre: ${new Date(
      sell.finishedDate
    ).toLocaleDateString()}\n`
    // sellsDetails.data += `Estado: ${getSellStatus(sell.status)}\n`
    sellsDetails.data += `Cliente: ${sell.client.name}\n`
    sellsDetails.data += `Vendedor: ${sell.seller}\n`
    sellsDetails.data += `Cantidad de Artículos: ${sell.numberOfItems}\n`
    sellsDetails.data += `Impuesto: ${sell.invoice.tax} %\n`
    sellsDetails.data += `Impuesto pagado: ${sell.invoice.taxBase} Bs\n`
    // sellsDetails.data += `Subtotal: ${sell.invoice.} Bs\n`
    sellsDetails.data += `Total: ${sell.invoice.total} Bs\n`
    const dataToShow = [sellsDetails]

    itemsDetails.title = 'Detalles de Artículos'
    if (sell.type === 'FREE FORM') {
      const { items } = sell.freeForm.freeFormDetail
      for (let i = 0; i < items.length; i++) {
        itemsDetails.data += `${i + 1}.- Artículo: ${items[i].name}\n`
        itemsDetails.data += `\tExento: ${items[i].exempt ? 'Sí' : 'No'}\n`
        itemsDetails.data += `\tPrecio: ${
          items[i].price[items[i].price.length - 1].amount
        } Bs\n`
      }
    } else {
      const { items } = sell.invoice.invoiceDetail
      for (let i = 0; i < items.length; i++) {
        itemsDetails.data += `${i + 1}.- Artículo: ${items[i].name}\n`
        itemsDetails.data += `\tExento: ${items[i].exempt ? 'Sí' : 'No'}\n`
        itemsDetails.data += `\tPrecio: ${
          items[i].price[items[i].price.length - 1].amount
        } Bs\n`
      }
    }

    dataToShow.push(itemsDetails)
    setDataWithTabs(dataToShow)
    setModalFromRow(true)
  }

  const onSubmitValues = async (values: any): Promise<void> => {
    console.log('VALUES', values)
    if (values?.isDateSelected) {
      const [dayFrom, monthFrom, yearFrom] = values.fromDate.split('/')
      const [dayTo, monthTo, yearTo] = values.toDate.split('/')

      console.log('VALUES 01', dayTo)
      console.log('VALUES 02', monthTo)
      console.log('VALUES 03', yearTo)
      console.log(
        'VALUES 04',
        new Date(yearTo, monthTo, +dayTo + 1).toISOString()
      )

      // const fromDate = new Date(yearFrom, monthFrom, dayFrom)

      const toDate = dateToDB(
        transformDate(new Date(yearTo, +monthTo - 1, +dayTo + 1).toISOString())
      )

      values.fromDate = `${yearFrom}-${monthFrom}-${dayFrom}`

      values.toDate = toDate
    }

    if (!values?.isDateSelected) {
      delete values.fromDate
      delete values.toDate
    }

    delete values.isDateSelected

    let param = Object.keys(values).reduce((a, b) => {
      if (values[b] !== '') {
        return [...a, `${b}=${values[b]}`]
      }
      return a
    }, [] as any)

    getSale(param, 0)
  }

  const sumOfValues = (prop: string): any => {
    if (onFormatITems()) {
      return onFormatITems().reduce(
        (a, b) => {
          a['iva'] += b.exempt
            ? 0
            : +(
                (+b?.price[b?.price?.length - 1]?.amount / Number(`1.${tax}`)) *
                (tax / 100)
              ) * +b?.amount
          a['exempt'] += b.exempt
            ? +b.price[b.price.length - 1]?.amount * +b.amount
            : 0
          a['sub_total'] += !b.exempt
            ? +(
                +(
                  +b?.price[b?.price?.length - 1]?.amount / Number(`1.${tax}`)
                ).toFixed(2) * +b.amount
              ).toFixed(2)
            : 0
          a['total'] += +b.price[b.price.length - 1]?.amount * +b.amount
          return a
        },
        { iva: 0, exempt: 0, total: 0, sub_total: 0 }
      )[prop]
    }
  }

  useEffect(() => {
    console.log('selected sale', selectedSale)
  }, [])

  const getTotalAmount = () =>
    +sumOfValues('sub_total').toFixed(2) +
    +sumOfValues('iva').toFixed(2) +
    +sumOfValues('exempt').toFixed(2)

  const formatRows = (): any => {
    let array = []
    if (selectedSale) {
      for (let i = 0; i < selectedSale.items?.length; i++) {
        let amount = selectedSale.itemSale?.find(
          (selected) => selected.id_item === selectedSale.items[i].id
        )?.amount

        if (amount) {
          let arraySub = [
            selectedSale.items[i].barcode || selectedSale.items[i].sku,
            selectedSale.items[i].name,
            amount,
            // selectedSale.items[i].exempt
            //   ? +selectedSale.items[i].price[0].amount
            //   : (
            //       +selectedSale.items[i].price[0].amount / Number(`1.${tax}`)
            //     ).toFixed(2),
            // selectedSale.items[i].exempt
            //   ? +selectedSale.items[i].price[0].amount * +amount
            //   : (
            //       +(
            //         +selectedSale.items[i].price[0].amount / Number(`1.${tax}`)
            //       ).toFixed(2) * +amount
            //     ).toFixed(2),
          ]
          //@ts-ignore
          array.push(arraySub)
        }
        return array
      }
    }
  }

  const itemsProps = () => {
    if (selectedSale?.type === 'FREE FORM') {
      return selectedSale.freeForm.freeFormDetail.items
    } else {
      return selectedSale?.invoice.invoiceDetail?.items
    }
  }

  const onGetRate = (idCurrency: string | undefined): string => {
    return globalRate.find((rate) => rate.id === idCurrency)?.rate || '1'
  }

  let subTotal = useMemo(() => {
    return reprintBody?.items?.reduce((a, b) => {
      return a + +b?.amount * +onGetRate(b?.currency?.id) * b?.price
    }, 0)
  }, [reprintBody])

  return (
    <div className={showPdf && selectedSale ? 'h-screen' : `h-full`}>
      {reprintBody && (
        <div style={{ height: '100vh' }}>
          <div
            className="flex items-center mt-3 mb-3 cursor-pointer"
            onClick={async () => {
              await getSale([], 0)
              setReprintBody(null)
            }}
          >
            <HiArrowLeft size={30} className="text-primary mr-2" />
            <label className="text-primary text-lg">Regresar</label>
          </div>
          <PdfSale
            cancelled={reprintBody?.cancelled}
            data={reprintBody?.items.map((item) => ({
              amount: item.amount,
              description: item?.name,
              individualPrice: +item?.price * +onGetRate(item?.currency?.id),
              totalPrice:
                +item?.price * +item?.amount * +onGetRate(item?.currency?.id),
            }))}
            subTotal={subTotal}
            exempt={reprintBody?.exempt}
            descuento={reprintBody?.discount}
            igtf={reprintBody?.igtf}
            //Iva general
            iva={reprintBody?.generalIVA}
            baseImponible={reprintBody?.generalTaxableBase}
            //Iva suntuario
            
            ivaSuntuario={reprintBody?.sumptuaryIVA}
            baseImponibleSuntuario={reprintBody?.sumptuaryTaxableBase}
            //Iva reducido
            reducedIVA={reprintBody?.reducedIVA}
            reducedTaxableBase={reprintBody?.reducedTaxableBase}
            total={reprintBody?.cost}
            // baseImponible={toFixed(+subTotal - +reprintBody?.exempt, 2)}
            client={{
              name: reprintBody?.client?.name,
              address: reprintBody?.client?.address,
              phone: reprintBody?.client?.phone1,
              state: reprintBody?.client?.state,
              city: reprintBody?.client?.city,
              rif: `${reprintBody?.client?.documentType}-${reprintBody?.client?.document}`,
            }}
            paidOut={reprintBody?.paidOut}
            invoiceNumber={reprintBody?.invoice?.code}
            creditNote={reprintBody.creditNote}
            isFromHistory={isFromHistory}
          />
        </div>
      )}
      {/* {showSellComponent && (
        <Sells
          setHeaderActions={setHeaderActions}
          clientProp={selectedSale?.client}
          // itemsProp={selectedSale?.items.map((item) => {
          //   let pending = selectedSale.itemSale?.find(
          //     (itemsale) => itemsale.id_item === item.id
          //   )
          //   return {
          //     ...item,
          //     amount: pending?.amount,
          //     id_item_sale: pending?.id_item_sale,
          //   }
          // })}
          itemsProp={itemsProps()}
          payment_methods={selectedSale?.payments.map((payment) => ({
            id: payment.account,
            amount: payment.amount,
            ref: payment.receipt,
            type: objReplace[payment.details],
          }))}
          statusProp="REFUND"
          selldId={selectedSale?.id}
        />
      )} */}

      {/* {showSale && selectedSale && (
        <Sells
          setHeaderActions={setHeaderActions}
          statusProp="DELIVERY_NOTE_TO_SALE"
          clientProp={selectedSale?.client}
          payment_methods={selectedSale?.payments.map((payment) => ({
            id: payment.account,
            amount: payment.amount,
            ref: payment.receipt,
            type: objReplace[payment.details],
            paymentStatus: TypeStatus.DONE,
            idTransaction: payment.id,
          }))}
          itemsProp={selectedSale.items.map((item) => {
            let pending = selectedSale.itemDeliveryNote?.find(
              (itemsale) => itemsale.id_item === item.id
            )
            return {
              ...item,
              amount: pending?.amount,
              id_item_sale: pending?.id_item_delivery_note,
              updated: true,
            }
          })}
          alreadySelledProp={
            selectedSale.paidOut && selectedSale.type === 'DISPATCHED'
          }
          selldId={selectedSale.id}
          type={selectedSale.type}
          paidOut={selectedSale.paidOut}
          dispatchStatusProps={selectedSale.type}
        />
      )} */}

      {!reprintBody && (
        <>
          <motion.div>
            <Table
              data={sells}
              columns={columns}
              pages={numberOfPages}
              pageSelected={currentPage}
              loading={loading}
              setPageSelected={(page) => getSale(searchParams, page)}
              setLoading={setLoading}
              getOrderKeys={getOrderKeys}
              // onPressButton={pressRow}
            />
          </motion.div>

          {/* {all.length > 0 &&
        !showSellComponent &&
        !showPdf &&
        selectedType === 'all' && (
          <motion.div>
            <Table
              data={all}
              columns={columnsAll}
              pages={numberOfPagesAll}
              pageSelected={currentPage}
              loading={loading}
              setPageSelected={setCurrentPage}
              setLoading={setLoading}
              getOrderKeys={getOrderKeys}
              onPressButton={pressRow}
            />
          </motion.div>
        )} */}

          {/* {deliveryNotes.length > 0 &&
        !showSellComponent &&
        !showPdf &&
        selectedType === 'deliveryNote' &&
        !showSale && (
          <motion.div>
            <Table
              data={deliveryNotes}
              columns={columnsDeliveryNotes}
              pages={numberOfPagesDeliveryNotes}
              pageSelected={currentPage}
              loading={loading}
              setPageSelected={setCurrentPage}
              setLoading={setLoading}
              getOrderKeys={getOrderKeys}
              onPressButton={pressRow}
            />
          </motion.div>
        )} */}

          {sells.length === 0 &&
            (selectedType === 'invoice' || selectedType === 'freeForm') && (
              <Empty
                animationProps={{
                  height: 200,
                  width: 200,
                  animation: EmptyHistoric,
                }}
                lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
              >
                <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
                  Una vez comiences a vender, podrás ver tu histórico de ventas
                </p>
              </Empty>
            )}

          {deliveryNotes.length === 0 && selectedType === 'deliveryNotes' && (
            <Empty
              animationProps={{
                height: 200,
                width: 200,
                animation: EmptyHistoric,
              }}
              lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
            >
              <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
                Una vez comiences a vender, podrás ver tu histórico de ventas
              </p>
            </Empty>
          )}

          {showPdf && selectedSale && (
            // <PDFViewer height="100%" width="100%">
            //   <InvoicePdf
            //     selectedClient={selectedSale.client}
            //     selectedItems={onFormatITems()}
            //     big={sumOfValues('sub_total').toFixed(2)}
            //     iva={sumOfValues('iva').toFixed(2)}
            //     total={getTotalAmount().toFixed(2)}
            //     exempt={sumOfValues('exempt').toFixed(2)}
            //     correlativeNumber={
            //       selectedSale.freeForm.freeFormDetail.correlativeNumber
            //     }
            //     createdDate={selectedSale.startedDate}
            //     createdTime={selectedSale.fixedDate}
            //     isSale={false}
            //   />
            // </PDFViewer>
            <PdfView
              downloadTitle={`FormaLibre-${'0'.repeat(
                6 -
                  selectedSale.freeForm.freeFormDetail.correlativeNumber.length
              )}${selectedSale.freeForm.freeFormDetail.correlativeNumber}`}
              column_styles={{ Cant: { width: 200 } }}
              type="FREE_FORM"
              footer_render={{
                sub_total: sumOfValues('sub_total').toFixed(2),
                iva: sumOfValues('iva').toFixed(2),
                exempt: sumOfValues('exempt').toFixed(2),
                total: getTotalAmount().toFixed(2),
                clientName: `${selectedSale.client.name} ${selectedSale.client.surname}`,
                clientDocument: `${selectedSale.client?.documentType}-${selectedSale.client?.document}`,
              }}
              title={`Factura - ${'0'.repeat(
                6 -
                  selectedSale.freeForm.freeFormDetail.correlativeNumber.length
              )}${selectedSale.freeForm.freeFormDetail.correlativeNumber}`}
              columns={[
                'Codigo',
                'Descripcion',
                'Cant',
                'Valor uni',
                'Valor Total',
              ]}
              data={formatRows()}
            />
          )}

          <ModalViewWithTabs
            display={modalFromRow}
            onClose={() => {
              setModalFromRow(false)
              setDataWithTabs([])
            }}
            dataWithTabs={dataWithTabs}
          />

          {/* <ModalSearchDate
        display={searchModal}
        onClose={() => setSearchModal(false)}
        form={filterForm}
        onSubmitValues={onSubmitValues}
      /> */}

          {/* <ModalSearchHistoric
        display={searchModal}
        onClose={() => setSearchModal(false)}
        onSubmitValues={onSubmitValues}
        type={selectedType}
      /> */}

          <FloatingForm
            visible={searchModal}
            onClose={() => setSearchModal(false)}
            topClass="top-16"
            rightClass="right-10"
            containerClass="w-2/6"
          >
            <FloatingSaleHistoricSearch
              onClose={() => setSearchModal(false)}
              onSubmitValue={onSubmitValues}
            />
          </FloatingForm>

          <Modal
            // modalClasses="w-2/5 py-4 px-12"
            display={modalDescription}
            onClose={() => setModalDescription(false)}
          >
            <>
              <DescriptionRefundForm
                onCancel={() => setModalDescription(false)}
                onSubmitDesctiption={(v) => {
                  setDescriptionRefund(v.description)
                  setShowConfirmModal(true)
                }}
              />
            </>
          </Modal>

          <ModalConfirm
            title={'Está seguro que desea anular esta venta?'}
            displayConfirmModal={showConfirmModal}
            onCancel={() => setShowConfirmModal(false)}
            onConfirm={async () => {
              try {
                addAlert({ message: 'Anulando venta...', status: 'loading' })
                await axios.delete(`${server}/sale?id=${deleteSaleId}`)
                getSale([], 0)
                setShowConfirmModal(false)
                addAlert({
                  message: 'Venta anulada con éxito',
                  status: 'success',
                })
              } catch (err: any) {
                console.log('err...', err?.response?.data?.message)
                if (
                  err?.response?.data?.message ===
                  "Sale can't be cancelled. It has associated payments."
                ) {
                  addAlert({
                    message:
                      'No se puede anular la venta. Tiene pagos asociados',
                    status: 'error',
                  })
                }
                if (
                  err?.response?.data?.message ===
                  "Sale can't be cancelled or deleted. It has associated payments and/or withholdings."
                ) {
                  console.log('Entrando en if...')
                  addAlert({
                    message: 'No se pueden eliminar ventas con pagos asociados',
                    status: 'error',
                  })
                  setShowConfirmModal(false)
                  return
                }
                if (
                  err?.response?.data?.message === 'Sale is already cancelled'
                ) {
                  addAlert({ message: 'Venta ya cancelada.', status: 'error' })
                  setShowConfirmModal(false)

                  return
                } else {
                  addAlert({
                    message: 'Error al anular venta',
                    status: 'error',
                  })
                }
                setShowConfirmModal(false)
              }
            }}
          />

          <Modal
            display={showAddPayment}
            onClose={async () => {
              await getSale([], 0)
              setShowAddPayment(false)
            }}
            xlClasses={`${windowSize.innerWidth < 1200 ? 'modal-width' : ''}`}
          >
            <AddPayments
              url="/sale/payment"
              purchase={addPaymentSelected}
              onClose={async () => {
                await getSale([], 0)
                setShowAddPayment(false)
              }}
              onAddPayment={() => setShowAddPaymentForm(true)}
              // newPayment={newPayment}
            />
          </Modal>

          <Modal
            display={showAddPaymentForm}
            xlClasses="xl:w-4/12"
            onClose={() => {
              // setShowAddPayment(false)
              setShowAddPaymentForm(false)
            }}
            contentStyle={{ overflow: 'initial' }}
          >
            <AddPaymentForm
              onClose={() => setShowAddPaymentForm(false)}
              onSubmit={async (values, accounts, selectedAccount) => {
                console.log('vall...', values)

                let accountSelected = accounts.find(
                  (v) => v?.id === selectedAccount?.value
                )

                console.log('account selcted', accountSelected)
                const [year, month, day] = getYearMonthAndDay(values.date)

                values.amount = formatPipe(values?.amount, true)

                values.account = {
                  id: values.account,
                }

                values.currency = {
                  id: accountSelected?.idCurrency,
                }

                delete values.paymentType
                values.rate = 1

                if (accountSelected?.idCurrency !== '2') {
                  let response = await axios.get(
                    `${server}/finances/rate?date=${dateToDB(
                      values.date
                    )}&currency=${accountSelected?.idCurrency}`
                  )
                  values.rate = response.data.rate.rate
                }

                let value = {
                  ...values,
                  new: true,
                  account: {
                    ...values?.account,
                    code: accountSelected?.description,
                  },
                  newDate: dateToDB(values?.date),
                  date: new Date(year, month, day).toISOString(),
                }

                // setNewPayment(prevState => ([...prevState, value]))

                setAddPaymentSelected((prevState) => ({
                  ...prevState,
                  payments: [...prevState?.payments, value],
                }))
                setShowAddPaymentForm(false)
              }}
            />
          </Modal>

          <Modal
            isFullHeight={true}
            innerStyle={{ height: '95%' }}
            xlClasses={`xl:w-10/12 xl:h-5/6 ${
              windowSize.innerWidth < 1200 && 'modal-width modal-height'
            }`}
            display={showReturnModal}
            onClose={async (fromPost, noteCode) => {
              if (fromPost) {
                await getSale([], 0)
              }
              if (noteCode) {
                setReprintBody({
                  ...returnSelected,
                  invoice: { code: null },
                  creditNote: noteCode,
                })
              }
              setShowReturnModal(false)
              setReturnSelected(null)
            }}
          >
            <Return
              url="sale"
              isFromReturn={fromReturn}
              purchase={returnSelected}
            />
          </Modal>

          <Modal
            xlClasses={`xl:w-10/12 xl:h-5/6 ${
              windowSize.innerWidth < 1200 && 'modal-width modal-height'
            }`}
            innerStyle={{ height: '95%' }}
            display={!!watchSale}
            onClose={() => setWatchSale(null)}
            isFullHeight={true}
          >
            <WatchSale
              sale={watchSale}
              onSeeDetails={() => setShowModalWithholdingDetails(true)}
              globalRate={globalRate}
            />
          </Modal>
        </>
      )}

      <Modal
        display={showWithholdingModal}
        onClose={() => setShowWithholdingModal(false)}
      >
        <WithholdingForm
          title={title}
          onClose={() => setShowWithholdingModal(false)}
          onSubmit={async (values) => {
            console.log('values...', values)
            if (values.document) {
              let s3InfoResponse: { value: any } = { value: {} }
              await uploadToS3(
                values.document,
                s3InfoResponse,
                `${user['custom:tenant_id']}/withholding/${selectedWithholding?.id}/${values.document.name}`,
                user['custom:tenant_id']
              )
            }
            let body = {
              ...values,
              id: selectedWithholding?.id,
            }
            if (title === 'ISLR') {
              // body.subtrahend = body.excempt
              delete body.excempt
            }

            if (title == 'Impuesto Municipal' || title === 'OTHER') {
              delete body.excempt
            }

            let transform = {
              ISLR: 'islr-withholding',
              IVA: 'withholding',
              'Impuesto Municipal': 'ae-withholding',
              OTHER: 'other-withholding',
            }

            const { document, ...rest } = body
            addAlert({ message: 'Creando retención', status: 'loading' })
            try {
              await axios.post(`${server}/sale/${transform[title]}`, rest)
              addAlert({
                message: 'Retención creada con éxito',
                status: 'success',
              })
              await getSale(searchParams, currentPage)

              setShowWithholdingModal(false)
            } catch (err) {
              addAlert({ message: 'Error al crear retención', status: 'error' })
            }
          }}
        />
      </Modal>

      <Modal
        display={otherWithholdingModal}
        onClose={() => setOtherWithholdingModal(false)}
      >
        <OtherWithholding />
      </Modal>

      <Modal
        display={showModalWithholdingDetails}
        onClose={() => setShowModalWithholdingDetails(false)}
        contentStyle={{ width: 1100 }}
      >
        <WatchWithholding sale={watchSale} />
      </Modal>

      <ModalConfirm
        onCancel={() => {
          setSelectedDeleteSale(null)
        }}
        onConfirm={async () => {
          addAlert({ message: 'Eliminando venta', status: 'loading' })
          try {
            await axios.delete(
              `${server}/sale?id=${selectedDeleteSale}&del=true`
            )
            await getSale([], 0)
            addAlert({
              message: 'Venta eliminada satisfactoriamente',
              status: 'success',
            })
          } catch (err) {
            addAlert({ message: 'Error al eliminar venta.', status: 'error' })
          } finally {
            setSelectedDeleteSale(null)
          }
        }}
        title="Advertencia"
        body="Al eliminar la ventana borraras todos los registros asociados a la misma, como pagos, retenciones y otros."
        displayConfirmModal={selectedDeleteSale !== null}
      ></ModalConfirm>
    </div>
  )
}

interface dateFilter {
  from?: any
  to?: any
  type: 'invoice' | 'date' | 'correlativeNumber' | 'creditNote'
  invoiceNumber?: string
  correlativeNumber?: string
  creditNote?: string
}

enum TypeStatus {
  DONE = 'DONE',
  UNDONE = 'UNDONE',
}

// enum TypeStatus {
//   DONE = 'DONE',
//   UNDONE = 'UNDONE'
// }
interface HistoricSellsProps {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderActions | null>>
}

export default HistoricSells
